import AsrClient from "@/utils/asrClient";
let DesktopPage_data = {
  data: function () {
    return {
      asrClient: new AsrClient(),
      // 当前系统是否开启了游客模式
      systemOpenGuestMode: false,
      // 游客的每日对话次数限制
      guestChatLimit: -1,
      // 当前的登录类型  1=>真实用户 2=>游客  -1=>未登录
      loginType: -1,
      // 是否达到游客限额
      isGuestOverLimit: false,
      // requestId  因为获取问答提示语是异步的，所以需要一个requestId来区分
      requestId_getSuggested: null,
      // 是否是手机号
      isPhoneNumber: false,
      // 是否是宽屏模式
      isWideScreen: true,
      wideWidth: 667,
      // 对话名称
      editChatName_inputValue: "",
      // markdown renderer 实例
      renderer: null,
      // websocket实例
      ws: null,
      // AI状态 是否是生成中
      isGenerating: false,
      // 用户输入内容
      inputContent: "",
      // 对话的选项框相关
      showChatPopover: false,
      chatPopoverOptions: [
        "setTop",
        "setUntop",
        "edit",
        "share",
        "report",
        "delete",
      ],
      chatPopoverTriggerEvent: null,
      // 登录选项
      showLoginPopover: false,
      loginPopoverTriggerEvent: null,
      // 原始发现列表
      findList: [],
      // 发现列表默认展示几条数据
      findListShowCount: 3,
      // 供组件使用的发现列表
      findListForSideBar: [],
      // 历史对话列表
      historyList: [],
      // 更多对话 相关
      showMoreChatPopover: false,
      // 更多对话列表
      moreChatList: [],
      moreChatPopoverTriggerEvent: null,
      // 是否登录
      isLogin: false,
      // 登录弹窗
      showLoginDialog: false,
      // 登录弹窗状态  1=>未获取验证码 2=>等待输入验证码
      loginDialogType: 1,
      // 用户输入的手机号
      inputPhoneNumber: "",
      // 用户手机号
      userPhoneNumber: "",
      // 是否同意服务协议
      hasAgreeAgreement: false,
      // 温馨提示弹窗
      showWarmHintDialog: false,
      // 登录 倒计时
      loginCountDown: 0,
      // 登录 倒计时定时器
      loginCountDownTimer: null,
      // 登录 输入的验证码
      loginCaptchaStr: "",
      // 登录 验证码数组
      loginCaptchaArr: [
        {
          error: false,
          focus: false,
          value: "",
        },
        {
          error: false,
          focus: false,
          value: "",
        },
        {
          error: false,
          focus: false,
          value: "",
        },
        {
          error: false,
          focus: false,
          value: "",
        },
      ],
      // 会话参数弹窗
      showChatInputsDialog: false,
      // 会话参数表单选项
      user_input_form: [],
      // 侧边栏是否可见
      showLeftSideBar: true,
      // 智能体详情 popup
      showChatDetailPopup: false,
      loading: false,
      // 任务id 供停止响应接口使用
      task_id: null,
      // 请求Id  前端生成
      requestId: null,
      // 文本生成异常 dialog
      showGeneratingErrorDialog: false,
      generatingErrorMsg: "",
      // 是否执行自动滚动
      isAutoScroll: false,
      // 是否等待滚动
      waitScroll: false,
      // 是否处于录音状态
      isRecording: false,
      // 是否处于转换中状态
      isTranslating: false,
      // 计时器
      timer: null,
      // 分钟
      dateTimeFormat: "00:00",
      // 一共多少秒钟
      second: 0,
      hasInsertNewChat: false,
      // 录音防抖锁
      recordDebounceLock: false,
      // 介绍
      prologue: "",
      // 开场白列表
      prologueList: [],
      // 当前对话
      currentChat: null,
      currentChat_ai_app_code: null,
      currentChat_conversation_id: null,
      chatDetail: null,
      // 当前对话内容  type 1=>正常文本内容  2=>问题建议
      chatContent: [],
      chatContentHasMore: false,
      chatContentLoading: false,
      // 提示语
      suggestedData: [],
      // 是否展示引导模块
      showAgentGuide: true,
      // 文件上传获得的数据
      dataFromUpload: [],
      // 已上传成功，待与会话一起发送的文件 取值后端返回文件id，待ws传回
      filesWaitUpload: [],
      // 已上传成功，待push到会话列表预览
      completeFiles: [],
      //最大可上传文件数
      maxUploadCnt: 0,
      // 是否显示文件上传按钮
      showFileUpload: false,
      // 引导模块数据
      guideList: [],
      // 默认写死999条
      pageNum: 1,
      pageSize: 999,
      currentCount: 0,
      totalCount: 0,
      currentTokenCount: 0,
      totalTokenCount: 0,
      vipTotalCount: 0,
      // 是否是会员
      isVip: false,
      // 删除对话的dialog
      showDeleteChatDialog: false,
      showDeleteChatDialog_fromDetail: false,
      // 退出登录的dialog
      showLogoutDialog: false,
      // 清除上下文的dialog
      showClearContextDialog: false,
      // 会话额度用完的dialog
      showTokenCountDialog: false,
      // 会员专属智能体dialog
      showVipOnlyDialog: false,
      // 修改对话名称的dialog
      showEditChatNameDialog: false,
      // 当前打开的对话气泡
      currentChatPopoverItem: null,
      // 新对话
      newChatInfo: null,
      // 默认对话
      defaultChatInfo: null,
      // 举报 dialog
      showReportDialog: false,
      // 举报类型
      reportTypeList: [],
      // 当前选中的举报类型
      currentReportType: null,
      // 举报原因
      reportContent: "",
      // 是否自动播放
      isAutoPlayVoice: false,
      // 是否隐藏TTS按钮
      hideTTSBtn: false,
      // ceo 效果列表
      ceoTextArr: [
        "识别意图中",
        "调取资料中",
        "智能匹配中",
        "检索片段中",
        "大模型生成中",
        "业务分析中",
        "结构化结果中",
        "完成",
      ],
      // ceo 动画是否播放完毕
      ceoAnimationPlayOver: false,
      // 本轮对话是否需要展示ceo 动画
      needPlayCeoAnimation: false,
      // ceo 文本是否生成完毕
      ceoAnimationMessageEnd: false,
      // 临时存储回答返回的字符串  用来跟业务编码的特殊抬头做匹配
      // 只找前几位，如果前几位不符合，直接放弃查找
      responseTempStr: "",
      // 本次查询是否匹配到了特殊抬头 0=>尚未匹配  1=>匹配成功（业务编码）  2=>匹配成功(深度思考)   99=>匹配失败
      isMatchSpecialHead: 0,
      // 深度思考是否思考完毕
      finishDeepSeek: false,
      // message_end error 异常情况：提问后，如果没返回message 直接返回了message_end 这里加一个开关区分一下
      message_end_error: false,
      // 当前播放的index下标
      playingContentIndex: -1,
      currentPlayingContentIndex: -1,
      // 本轮对话是否已经播放过（即便是播放失败）
      currentHasAutoPlaying: false,
      // 播放器dom实例
      audioPlayer: null,
      mediaSource: null,
      controller: null,
      signal: null,
      sourceBuffer: null,

      // 是否显示滚动到底部按钮
      ShowScrollToBottomBtn: false,
      // 是否记录本轮提问的自动播放状态
      isAutoPlayVoice_current: false,

      // modal_card data
      modal_card: null,
      textareaFocus: false,
      // 是否显示前往底部按钮
      showGoToBottomBtn: false,
      stopViewportMonitoring: null,
      //   原始可视高度
      visualViewportHeight_origin: 0,
      //   原始可视高度-当前可视高度  高度差
      visualViewportHeight_difference: 0,
      // 是否展示合并弹窗
      showMergeGuestDialog: false,
      guestSessionId: null,
      // 音波条数据（5条）
      soundWaveBars: [
        { height: 5 },
        { height: 5 },
        { height: 5 },
        { height: 5 },
        { height: 5 },
      ],
    };
  },
};

export { DesktopPage_data };
